// extracted by mini-css-extract-plugin
export default {"card":"EjercicioCard_card__jCIxJ","textarea":"EjercicioCard_textarea__6-pZN","title":"EjercicioCard_title__4FaP5"};